// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.translation-buttons-container {
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.translation-buttons-container-main {
  margin-right: 36px;
  margin-top: -6px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
}
.translation-buttons-container-main .button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border: none;
}
.translation-buttons-container-main .experimental-text {
  position: relative;
  bottom: -8px;
  display: flex;
  flex-direction: row;
  font-size: 0.7rem;
  justify-content: flex-end;
}

.translation-button {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background-color: white;
  border: none;
  color: #0669B3;
  font-size: 0.7em;
  font-weight: 600;
  height: 22px;
  margin-left: 10px;
  transition: 0.1s ease;
  width: 80px;
}
.translation-button:hover {
  background: #63AEDE;
  color: white;
  color: black;
  font-weight: 500;
}
.translation-button:active {
  color: #D1D3D4;
}

@media only screen and (max-width: 768px) {
  .translation-buttons-container-main {
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["data:;charset=utf-8,*,%0A*::before,%0A*::after%20%7B%0A%20%20%20%20box-sizing:%20border-box;%0A%7D%0A/%20Guardian%20Dashboard%20colors%0A$lt-blue:%20%237DB7CC;%0A$dk-blue:%20%2319608f;%0A%0A$error:%20%23CE3525;%0A$error-dk:%20%23aa3333;%0A$error-hover:%20%23cf4635;%0A$hover-white:%20%23E0E0E0;%0A$light-background:%20%23EFEFEF;%0A%0A$information:%20%2300AEEF;%0A$information-hover:%20%2302BFFF;%0A$text:%20%23414042;%0A$white:%20%23EDEDED;%0A$shadow:%20%23525151;%0A$red:%20%23CB321A;%0A$green:%20%234a8319;%0A%0A$important:%20%23FEBF31;%0A$greyLight:%20%23F8F8F8;%0A$grey0:%20%23EDf0F1;%0A$grey1:%20%23D1D3D4;%0A$grey2:%20%23A7A9AC;%0A$grey3:%20%23808080;%0A$grey3a:%20%23707070;%0A$grey4:%20%23636161;%0A$grey4a:%20%23444343;%0A$pale-blue:%20%23C0DEF0;%0A$pearl-blue:%20%230669B3;%0A$pearl-blue-hover:%20%231786DB;%0A$lt-pearl-blue:%20%2363AEDE;%0A$lt-pearl-blue-hover:%20%234589B3;%0A$icon-blue:%20%234DD9FF;%0A","webpack://./src/styles/TranslationButton.scss","data:;charset=utf-8,@use%20%22./Colors.scss%22;%0A%0A@mixin%20borderRadius($radius:%205px)%20%7B%0A%20%20%20%20border-radius:%20$radius;%0A%7D%0A%0A@mixin%20dialogueBold()%20%7B%0A%20%20%20%20font-weight:%20600;%0A%20%20%20%20font-size:%20.9em;%0A%7D%0A%0A@mixin%20input()%20%7B%0A%20%20%20%20border-radius:%205px;%0A%20%20%20%20font-weight:%20400;%0A%20%20%20%20width:%20100%25;%0A%7D%0A%0A@mixin%20infoRounded($radius)%20%7B%0A%20%20%20%20background:%20Colors.$information;%0A%20%20%20%20border-bottom-left-radius:%20$radius;%0A%20%20%20%20border-bottom-right-radius:%20$radius;%0A%7D%0A%0A@mixin%20shadow()%20%7B%0A%20%20%20%20box-shadow:%200.1rem%200.15rem%200.3rem%200%20Colors.$shadow;%0A%7D%0A%0A@mixin%20shadowCustom($hor:%201px,%20$vert:%201px,%20$blur:%202px,%20$color:%20Colors.$shadow)%20%7B%0A%20%20%20%20box-shadow:%20$hor%20$vert%20$blur%20$color;%0A%7D%0A%0A@mixin%20shadowBottom()%20%7B%0A%20%20%20%20box-shadow:%200%200.1rem%200.15rem%200%20Colors.$shadow;%0A%7D%0A%0A@mixin%20standardInputContainer()%20%7B%0A%20%20%20%20font-weight:%20500;%0A%20%20%20%20font-size:%20.9rem;%0A%20%20%20%20margin:%2010px%200;%0A%7D%0A%0A@mixin%20standardInput()%20%7B%0A%20%20%20%20@include%20borderRadius(5px);%0A%20%20%20%20border:%20none;%0A%20%20%20%20border:%201px%20solid%20Colors.$grey3;%0A%20%20%20%20padding:%205px;%0A%7D%0A"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AAIF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAIF;AAFE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAIJ;AADE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAGJ;;AACA;EC/BI,kBDgCiC;ECXjC,2CAAA;EDaF,uBAAA;EACA,YAAA;EACA,cDNW;ECOX,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAEF;AAAE;EACE,mBDbY;ECcZ,YAAA;EACA,YAAA;EACA,gBAAA;AAEJ;AACE;EACE,cD7BI;AC8BR;;AAGA;EACE;IACE,eAAA;EAAF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
